//create axios instance
import axios from "axios";
import cookieCutter from "cookie-cutter";

const AuthAPI = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE_URL,
  timeout: 30000, // 30 second timeout
});

// Request interceptor to add token to headers
AuthAPI.interceptors.request.use(
  (config) => {
    const token = cookieCutter.get("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default AuthAPI;

